import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/mergingAction";
import * as uiHelpers from "../MergingUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useDistributionMergingUIContext } from "../MergingUIContext";
import { BlockOrg, RoleChecker } from "../../../../../RoleChecker";
import { Table } from "react-bootstrap";

const DistributionMergingTable = ({
  distributionData = {},
  setDistributionData,
  onSubmit,
}) => {
  // DistributionMerging UI Context
  const distributionMergingUIContext = useDistributionMergingUIContext();
  const distributionMergingUIProps = useMemo(() => {
    return {
      queryParams: distributionMergingUIContext.queryParams,
      setQueryParams: distributionMergingUIContext.setQueryParams,
      newDistributionMergingIndividuButtonClick:
        distributionMergingUIContext.newDistributionMergingIndividuButtonClick,
      openDeleteDistributionMergingPage:
        distributionMergingUIContext.openDeleteDistributionMergingPage,
      openEditDistributionMergingIndividualPage:
        distributionMergingUIContext.openEditDistributionMergingIndividualPage,
      openEditDistributionMergingOrganizationPage:
        distributionMergingUIContext.openEditDistributionMergingOrganizationPage,
    };
  }, [distributionMergingUIContext]);

  // Getting curret state of distributionMerging list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.distributionMerging }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const checkAllFunction = (e) => {
    let newArr = [];
    entities.forEach((item, i) => {
      if (e.target.checked) {
        newArr.push(item.uuid);
        document.getElementById(`checkbox_${i}`).checked = e.target.checked;
      } else {
        newArr = [];
        document.getElementById(`checkbox_${i}`).checked = e.target.checked;
      }
    });
    setDistributionData((prev) => ({
      ...prev,
      donation_item_uuids: newArr,
    }));
  };

  const onChangeChecked = (e, item) => {
    const arrayCopy = [...distributionData.donation_item_uuids];
    if (e.target.checked) {
      setDistributionData((prev) => ({
        ...prev,
        donation_item_uuids: [
          ...distributionData.donation_item_uuids,
          item.uuid,
        ],
      }));
    } else {
      const newArr = arrayCopy.filter((uuid) => uuid !== item.uuid);
      setDistributionData((prev) => ({
        ...prev,
        donation_item_uuids: newArr,
      }));
    }
  };

  return (
    <>
      <Table hover>
        <thead>
          <tr>
            <th>
              <input type="checkbox" onChange={(e) => checkAllFunction(e)} />
            </th>
            <th className="text-muted">NO</th>
            <th className="text-muted">ID DONASI</th>
            <th className="text-muted">ID DONATUR</th>
            <th className="text-muted">ATAS NAMA</th>
          </tr>
        </thead>
        <tbody>
          {entities.map((item, index) => (
            <>
              <tr>
                <td>
                  <input
                    id={`checkbox_${index}`}
                    type="checkbox"
                    onChange={(e) => onChangeChecked(e, item)}
                  />
                </td>
                <td>{index + 1}</td>
                <td>{item.donation.donation_hid}</td>
                <td>{item.donation.donor.name}</td>
                <td>{item.name_1}</td>
              </tr>
            </>
          ))}
        </tbody>
      </Table>
      {RoleChecker("Update", "distribution") && entities.length > 0 && (
        <div>
          <button
            className="btn btn-primary float-right"
            onClick={onSubmit}
            disabled={distributionData.donation_item_uuids.length <= 0}
          >
            Distribusikan
          </button>
        </div>
      )}
    </>
  );
};

export default DistributionMergingTable;
